import { Fragment } from 'react'

import { Link } from '@tanstack/react-router'

import { useTSRBreadcrumbs } from '@/hooks/use-tanstack-breadcrumbs'

import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'

export const Breadcrumbs = () => {
	const { breadcrumb_routes } = useTSRBreadcrumbs()

	const parseRouteName = (name: string) => {
		if (/air/i.test(name)) {
			return 'AIR®'
		}

		return name
	}

	return (
		<Breadcrumb>
			<BreadcrumbList>
				{breadcrumb_routes.map((route, index) => {
					const isLast = index === breadcrumb_routes.length - 1

					if (isLast) {
						return (
							<BreadcrumbItem key={route.path}>
								<BreadcrumbPage className="capitalize">
									{parseRouteName(decodeURIComponent(route.name))}
								</BreadcrumbPage>
							</BreadcrumbItem>
						)
					}

					return (
						<Fragment key={route.path}>
							<BreadcrumbItem>
								<BreadcrumbLink render={<Link to={route.path} />}>
									{parseRouteName(route.name)}
								</BreadcrumbLink>
							</BreadcrumbItem>
							<BreadcrumbSeparator />
						</Fragment>
					)
				})}
			</BreadcrumbList>
		</Breadcrumb>
	)
}
